import React, { useContext, useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import BeaconDataTable from "./BeaconDataTable";
import AddAssetForm from "./AddAssetForm";
import AssetDataTable from "./AssteDataTable";
import UpdateMacIdsForm from "./UpdateMacIdsForm";
import AssetGraph from "./AssetGraph";
import AllMacGraph from "./AllMacGraph";
import BasicCard from "./Cards";
import AppContext from "../context/AppContext";
import GatewayLogsTable from "./GatewayLogsTable";
import axios from "axios";
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import AssetReport from "./Report/AssetReport";
function DashboardPage() {
  const currentDate = new Date();
  const oneDayBefore = new Date(currentDate);
  oneDayBefore.setHours(currentDate.getHours() - 4);
  let localStartTime = new Date(
    oneDayBefore.getTime() - oneDayBefore.getTimezoneOffset() * 60000
  );
  let localEndTime = new Date(
    currentDate.getTime() - currentDate.getTimezoneOffset() * 60000
  );

  const { location, gateway, asset, userRole } = useContext(AppContext);
  const [selected, setSelected] = useState({});
  const [count, setCount] = useState();
  const [filter, setFilter] = useState("default");
  const [loading , setLoading] = useState(false)
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [dateRange, setDateRange] = useState({
    start: localStartTime,
    end: localEndTime,
  });
  
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(()=>{
    const handleResize = ()=> setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return ()=> window.removeEventListener("resize", handleResize);
  },[isMobile])


  function subtractTime(inputTime, hours, minutes) {
    let [datePart, timePart] = inputTime.split(" ");

    let [hoursStr, minutesStr, secondsStr] = timePart.split(":").map(Number);

    hoursStr -= hours;
    minutesStr -= minutes;

    if (minutesStr < 0) {
      minutesStr += 60;
      hoursStr--;
    }
    if (hoursStr < 0) {
      hoursStr += 24;
    }

    let updatedTime = `${hoursStr.toString().padStart(2, "0")}:${minutesStr
      .toString()
      .padStart(2, "0")}:${secondsStr}`;

    return `${datePart} ${updatedTime}`;
  }

  useEffect(() => {
    setLoading(true)

    const fetchData = async () => {
      try {
        let formattedStartTime = dateRange.start
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        let formattedEndTime = dateRange.end
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");

        // formattedStartTime= subtractTime(formattedStartTime, 5, 30)
        // formattedEndTime= subtractTime(formattedEndTime, 5, 30)

        let selectedLocation = [];
        let locationsSelected = [...selectedLocations];
        locationsSelected.map((location) => selectedLocation.push(location.id));
        let response;
        if( filter == 'default'){
          response = await axios.post(
            `${process.env.REACT_APP_URL}/api/v1/beacon/connected/asset`,
            {
              // `http://localhost:5002/api/v1/beacon/connected/asset`,{
              start_time: formattedStartTime,
              end_time: formattedEndTime,
              location_ids: selectedLocation,
            }
          );
        }
        else {
          response = await axios.post(
            `${process.env.REACT_APP_URL}/api/v1/beacon/connected/asset/rssi`,
            {
              // `http://localhost:5002/api/v1/beacon/connected/asset`,{
              start_time: formattedStartTime,
              end_time: formattedEndTime,
              location_ids: selectedLocation,
            }
          );
        }

        if (response.data.status == "success") {
          setSelected(response.data.locations);
        }
        const response_count = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/beacon/counts`
        );
        // `http://localhost:5002/api/v1/beacon/counts`);

        if (response_count.data.status == "success") {
          setCount(response_count.data);
          setLoading(false)
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 1000);

    return () => clearInterval(interval);
  }, [dateRange, selectedLocations, filter]);

  const handleLocationChanges = (e, newLocation) => {
    setSelectedLocations(newLocation);
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4} lg={4}>
            <BasicCard
              name="Total Location"
              loading={loading}
              total={count?.location_count}
              connected=""
              disconnected=""
              connectedCount=""
              disconnectedCount=""
            />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <BasicCard
              name="Gateway"
              loading={loading}
              total={count?.gateway_count}
              connected="Con(1 day)"
              disconnected="Discon(1 day)"
              connectedCount={count?.connected_gateways_count}
              disconnectedCount={count?.disconnected_gateways_count}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <BasicCard
              name="Assets"
              loading={loading}
              total={count?.asset_count}
              connected="Con(1 day)"
              disconnected="Discon(1 day)"
              connectedCount={count?.connected_assets_count}
              disconnectedCount={count?.disconnected_assets_count}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              style={{ marginTop: 10, marginBottom: 10 }}
            >
              <Grid item>
                <Autocomplete
                  multiple
                  limitTags={2}
                  id="multiple-limit-tags"
                  options={location}
                  getOptionLabel={(option) => option?.name}
                  value={selectedLocations}
                  onChange={(e, newVal) => handleLocationChanges(e, newVal)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="All Location"
                      placeholder="Locations"
                    />
                  )}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#50C1E9",
                      },
                      "&:hover fieldset": {
                        borderColor: "#50C1E9",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#50C1E9",
                      },
                      width:isMobile ? "300px" : "250px",
                    },
                  }}
                  // sx={{  }}
                />
              </Grid>
              <Grid item>
                <TextField
                  label="Start Time"
                  type="datetime-local"
                  value={dateRange.start.toISOString().slice(0, 16)}
                  onChange={(e) => {
                    let currentTime = new Date(e.target.value);
                    let localTime = new Date(
                      currentTime.getTime() -
                        currentTime.getTimezoneOffset() * 60000
                    );
                    setDateRange({ ...dateRange, start: localTime });
                  }}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      fontWeight: 700,
                      color: "#005778",
                      fontSize: 16,
                    },
                  }}
                  InputProps={{
                    style: {
                      fontSize: 15,
                      color: "rgba( 0, 0, 0, 70% )",
                      height: 55,
                    },
                  }}
                  style={{ marginRight: 30 }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#50C1E9",
                      },
                      "&:hover fieldset": {
                        borderColor: "#50C1E9",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#50C1E9",
                      },
                      width : isMobile ? "300px" : "100%", 
                    },
                  }}
                />
              </Grid>
              <Grid item>
                <TextField
                  label="End Time"
                  type="datetime-local"
                  value={dateRange.end.toISOString().slice(0, 16)}
                  onChange={
                    (e) => {
                      let currentTime = new Date(e.target.value);
                      let localTime = new Date(
                        currentTime.getTime() -
                          currentTime.getTimezoneOffset() * 60000
                      );
                      setDateRange({ ...dateRange, end: localTime });
                    }
                    // setDateRange({ ...dateRange, end: new Date(e.target.value) })
                  }
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      fontWeight: 700,
                      color: "#005778",
                      fontSize: 16,
                    },
                  }}
                  InputProps={{
                    style: {
                      fontSize: 15,
                      color: "rgba( 0, 0, 0, 70% )",
                      height: 55,
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#50C1E9",
                      },
                      "&:hover fieldset": {
                        borderColor: "#50C1E9",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#50C1E9",
                      },
                      width : isMobile ? "300px" : "100%",
                    },
                  }}
                  style={{ marginRight: 30 }}
                />
              </Grid>
              <Grid item>
              <FormControl>
                  <InputLabel id="demo-simple-select-label">
                    Filter
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={filter}
                    label="Filter"
                    style={{ width:isMobile ? "300px" : 200, marginBottom:isMobile ? "2px" : 40 }}
                    onChange={(e) => setFilter(e.target.value)} 
                  >
                    <MenuItem value="rssi">RSSI</MenuItem>
                    <MenuItem value="default">Default</MenuItem> 
                  </Select>
                </FormControl>    
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <AllMacGraph selected={selected} />
          </Grid>
          <Grid item xs={12}>
            <AssetGraph selected={selected} filter={filter} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant={"h6"}
          style={{ color: "#07689f", fontSize: "24px", fontWeight: "bold" }}
          noWrap
        >
          Assets Tracking
        </Typography>
        {/* <AssetDataTable /> */}
        <AssetReport />
      </Grid>
    </Grid>
  );
}

export default DashboardPage;
